import { createContext, useContext } from 'react';

import { DateControlCommitApi } from 'app/components/Controls/DateControl/DateControl.interfaces';

export type TravelDateRangeRole = 'start' | 'end';

export interface TravelDateRangeFieldApi extends DateControlCommitApi {
  minDate?: string;
  maxDate?: string;
}

export type TravelDateRangeFieldGetter = (
  role: TravelDateRangeRole
) => TravelDateRangeFieldApi | undefined;

export interface TravelDateRangeContextInterface {
  registerField: (
    role: TravelDateRangeRole,
    api: TravelDateRangeFieldApi
  ) => void;
  openRange: (role: TravelDateRangeRole) => void;
  isRangeDialogOpen: boolean;
}

export const TravelDateRangeContext = createContext<TravelDateRangeContextInterface | null>(
  null
);

export function useTravelDateRangeContext() {
  return useContext(TravelDateRangeContext);
}
